import { Context } from 'react'
import ImpregnationTab from '../components/ImpregnationTab'
import { IMainComponent } from 'src/generated-types/main-component'
import { IImpregnation } from 'src/generated-types/impregnation'

interface Props {
  context: Context<any> | null | undefined
  serviceStationId?: EntityId
  mainComponentId: any
  mainComponent: IMainComponent
  onAddImpregnation: (initialValues: IImpregnation | undefined) => void
  height?: string
  autoHeight?: boolean
  maxVisibleRowCount?: number
  minimalEmptyStatus?: boolean
  setDataLength?: (length: number) => void
  disabled?: boolean
}

const ImpregnationInEquipment = (props: Props) => {
  const {
    context,
    serviceStationId,
    mainComponentId,
    mainComponent,
    height,
    autoHeight,
    maxVisibleRowCount,
    minimalEmptyStatus,
    setDataLength,
    disabled,
  } = props

  return (
    <ImpregnationTab
      mainComponentId={mainComponentId}
      context={context}
      mainComponentStatus={mainComponent?.status}
      serviceStationId={serviceStationId}
      withoutLayout={true}
      onAddImpregnation={props.onAddImpregnation}
      height={height}
      autoHeight={autoHeight}
      maxVisibleRowCount={maxVisibleRowCount}
      minimalEmptyStatus={minimalEmptyStatus}
      setDataLength={setDataLength}
      disabled={disabled}
    />
  )
}

export default ImpregnationInEquipment
